import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";

export const CardSkeleton = () => {
  return (
    <>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <Skeleton variant="rounded" width="100%" height={250} />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <Skeleton variant="rounded" width="100%" height={250} />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <Skeleton variant="rounded" width="100%" height={250} />
      </Grid>
    </>
  );
};
